export class MiniGallery{
	init(){
		var miniGalleryLength 	= $('.mini-gallery').length,
				noGridGalleryLength = $('.js-no-grid').length;

		if( miniGalleryLength ){
			for(var i = miniGalleryLength; i--;){
				var element = $('.mini-gallery')[i];
				$(element).magnificPopup({
					delegate: 'a',
					type: 'image',
					closeOnContentClick: true,
					closeBtnInside: false,
					fixedContentPos: true,
					mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
					image: {
					  verticalFit: true
					},
					tLoading: 'Ładuję...',
					gallery: {
				      enabled: true,
					  tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
				    },
					zoom: {
						enabled: false,
						duration: 300 // don't foget to change the duration also in CSS
					}
				});
			}
		}


		if(noGridGalleryLength){
			var noGridGalleries = $('.js-no-grid');
			noGridGalleries.each(function(galleryId, gallery){
				var galleryItems 						= $(gallery).find('.js-no-grid-item'),
						galleryColumns 					= $(gallery).data('columns') ? $(gallery).data('columns') : 3,
						galleryContainerColumns = null,
						galleryItemsArary 			= [];


				var galleryContainer = $('<div class="row"></div>');
				for(var i=0; i<galleryColumns; i++){
					var galleryCol 	= $('<div class="col-md-'+(12/galleryColumns)+'"></div>');
					galleryContainer.append(galleryCol);
				}

				$(gallery).append(galleryContainer);
				galleryContainerColumns = galleryContainer.find('[class*="col-md"]');

				galleryItems.each(function(id, galleryItem){
					var minHeight 	= 10000000000,
							selectedCol = null;
					for(var i=0; i<galleryContainerColumns.length; i++){
						var colHeight = $(galleryContainerColumns[i]).height();
						
						if(colHeight < minHeight){
							minHeight = colHeight;
							selectedCol = $(galleryContainerColumns[i]);
						}
					}
					selectedCol.append($(galleryItem).clone(true));
				});
				$(gallery).html(galleryContainer);
			});
		}
	}
}